export enum RedirectionTargets {
  OrderList = 'ORDER_LIST',
  ReservationsList = 'RESERVATIONS_LIST',
  ObjectEntity = 'OBJECT_ENTITY',
}
